export default "__VITE_ASSET__TURhzF1S__"